export default {"src":"/_next/static/media/warning_icon.04d97c6e.svg","height":138,"width":160,"blurWidth":0,"blurHeight":0};